import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { DropdownDialogComponent } from '@app/shared/dropdown-dialog/dropdown-dialog.component';

@NgModule({
  declarations: [DropdownDialogComponent],
  imports: [CommonModule, TranslateModule, MatIconModule, MatDialogModule],
  exports: [DropdownDialogComponent],
})
export class DropdownDialogModule {}
